import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { MaskLine } from "../components/Motion";

const FAQS = [
  ["What does pre-order mean?", "This is a limited first-run pre-order. You're charged today to reserve your piece, and it ships during the estimated window shown on the product page (week of Sep 15)."],
  ["When will my order ship?", "First-drop pre-orders ship the week of September 15, 2026. You'll get tracking by email the moment it leaves us."],
  ["How do the sizes fit?", "Tees run oversized and boxy — size down for a regular fit. Jorts are baggy and long-line. Full measurements are in the size guide on each product page."],
  ["What's your return policy?", "Free returns within 14 days of delivery on unworn items with tags. Pre-orders can be cancelled any time before they ship."],
  ["Is 8% really donated?", "Yes — 8% of every order goes to organizations clothing people in poverty who struggle with the cold. No rounding down, every drop."],
  ["Do you ship internationally?", "We currently ship to the US, Canada, UK and Australia. Duties and taxes are calculated at checkout."],
];

export default function FAQ() {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-8 py-16 sm:py-24" data-testid="faq-page">
      <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-graytx mb-4">Answers</p>
      <h1 className="font-display font-extrabold text-6xl sm:text-8xl uppercase leading-[0.85]"><MaskLine>FAQ</MaskLine></h1>
      <Accordion type="single" collapsible className="mt-12 border-t border-line">
        {FAQS.map(([q, a], i) => (
          <AccordionItem key={i} value={`f${i}`} className="border-line">
            <AccordionTrigger className="font-display text-lg text-left" data-testid={`faq-${i}`}>{q}</AccordionTrigger>
            <AccordionContent className="text-graytx leading-relaxed">{a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
}
